<div class="edit-pricing-container">
  <div class="product-header" *ngIf="hasProductLabelInfo()">
    <div class="company-card">
      <div class="company-logo">
        <img src="./assets/icons/no-logo-company-icon.svg" />
      </div>
      <div class="company-container">
        <div class="company-data">
          <span class="company-name">{{ productLabelInfo.getProductName() }} </span>
          <span class="company-cnpj"> <b>INFO: </b>{{ productLabelInfo.getPresentation() }} | <b>EAN: </b>{{ productLabelInfo.getEan1() }} </span>
        </div>
        <div class="last-modified" *ngIf="pricingsLastModified">
          Última alteração dos preços:
          {{ pricingsLastModified | date: "dd/MM/yyyy HH:mm:ss" }}
        </div>
      </div>
    </div>
  </div>
  <div class="state-list-container">
    <div *ngIf="!hasPricingStateViewItems()">
      <p>Carregando preços...</p>
    </div>
    <mat-card-content *ngIf="hasPricingStateViewItems()">
      <mat-accordion *ngFor="let item of getPricingStateViewItems(); let i = index">
        <mat-expansion-panel *ngIf="item.getPricingInfoViewItems().length > 0">
          <mat-expansion-panel-header>
            <mat-panel-title [ngClass]="{ changed: item.hasChanged() }">
              {{ item.getProductState().getName() }}
              <pre *ngIf="item.hasChanged()"> - ALTERADO</pre>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="form-container" *ngFor="let pricing of item.getPricingInfoViewItems()">
            <form *ngIf="pricing.getPricingQuotaConfiguration().isFreeCommercialArea()" [formGroup]="getFormGroup(pricing.getPricingKey())">
              <div class="alc-header">
                <p>Área de Livre Comércio</p>
                <img src="./assets/icons/eraser-icon.svg" (click)="resetPrices(pricing); onDataChange(item)" />
              </div>
              <div class="fields-holder">
                <mat-form-field appearance="outline">
                  <mat-label>Preço</mat-label>
                  <input matInput type="number" min="0" step="any" formControlName="price" placeholder="Preço" (change)="onDataChange(item)" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Preço Máximo</mat-label>
                  <input matInput type="number" min="0" step="any" formControlName="maxPrice" placeholder="Preço Máximo" (change)="onDataChange(item)" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Cota (%)</mat-label>
                  <input matInput type="number" min="1" max="100" formControlName="quota" placeholder="Cota (%)" readonly />
                </mat-form-field>
              </div>
            </form>
            <form *ngIf="!pricing.getPricingQuotaConfiguration().isFreeCommercialArea()" [formGroup]="getFormGroup(pricing.getPricingKey())">
              <div class="alc-header">
                <p>Área de <b>Não</b> Livre Comércio</p>
                <img src="./assets/icons/eraser-icon.svg" (click)="resetPrices(pricing)" />
              </div>
              <div class="fields-holder">
                <mat-form-field appearance="outline">
                  <mat-label>Preço</mat-label>
                  <input matInput type="number" min="0" step="any" formControlName="price" placeholder="Preço" (change)="onDataChange(item)" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Preço Máximo</mat-label>
                  <input matInput type="number" min="0" step="any" formControlName="maxPrice" placeholder="Preço Máximo" (change)="onDataChange(item)" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Cota (%)</mat-label>
                  <input matInput type="number" min="1" max="100" formControlName="quota" placeholder="Cota (%)" readonly />
                </mat-form-field>
              </div>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </div>
  <div class="btn-conatiner">
    <button mat-flat-button class="back-search-btn" (click)="backToSearchProduct()">VOLTAR PARA PESQUISA</button>
    <button mat-flat-button class="back-btn" (click)="backToProductEdit()">VOLTAR</button>
    <button *ngIf="hasAccessToEditProductPricing()" mat-flat-button class="save-btn" (click)="savePrices()">SALVAR ALTERAÇÕES</button>
  </div>
</div>
